import type { Coordinates } from './google-maps-input.ts'

/** Resolves the device location, or null when it is unavailable or denied. */
export type DeviceLocationSource = () => Promise<Coordinates | null>

const DEVICE_LOCATION_TIMEOUT = 10_000

let browserDeviceLocation: Promise<Coordinates | null> | undefined

/** Asks the browser Geolocation API once per page load; any failure resolves to null. */
export const getBrowserDeviceLocation: DeviceLocationSource = () => {
  browserDeviceLocation ??= new Promise(resolve => {
    if (!('geolocation' in navigator)) {
      resolve(null)
      return
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => resolve({ lat: coords.latitude, lng: coords.longitude }),
      () => resolve(null),
      { maximumAge: Number.POSITIVE_INFINITY, timeout: DEVICE_LOCATION_TIMEOUT },
    )
  })

  return browserDeviceLocation
}
